module.exports = __webpack_public_path__ + "img/ic_foot_hight_3.5d371013.png";